/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnlinkAllInstrumentLinksRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UnlinkAllInstrumentLinks.pb'
import {UnlinkAllInstrumentLinksResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UnlinkAllInstrumentLinks.pb'


export const unlinkAllInstrumentLinks = (request:UnlinkAllInstrumentLinksRequest, options?: CashRequestOptions) => post<UnlinkAllInstrumentLinksRequest, UnlinkAllInstrumentLinksResponse>("/2.0/cash/unlink-all-instrument-links", request, {...options, rejectOnError: true })